import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function StaticPages() {
  const navigate = useNavigate();
  const pages = [{
    id: 1,
    title: 'About Us',
    text: 'Learn about our history...',
    param: 'about-us'
  }, {
    id: 2,
    title: 'Privacy Policy',
    text: 'Your privacy matters...',
    param: 'privacy'
  }, {
    id: 3,
    title: 'Terms of Service',
    text: 'Please read carefully...',
    param: 'terms'
  }];
  return <div className="space-y-4" data-id="element-1625" data-mp="91uftp9mf265">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1626" data-mp="90t037hntri3">Static Pages</h1>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1627" data-mp="442ksmdoizxq">
        <div className="overflow-x-auto" data-id="element-1628" data-mp="11iesz5nie3e8">
          <table className="w-full text-sm text-left" data-id="element-1629" data-mp="11jgfq7dw0ebs">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1630" data-mp="ws873dkdswzo">
              <tr data-id="element-1631" data-mp="wpvg6awnbcah">
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1632" data-mp="w78atv2t2de4">Title</th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1633" data-mp="w9cq1965mytp">Text</th>
                <th className="px-3 py-3 border-r border-slate-700 w-32" data-id="element-1634" data-mp="107jxtein4psr">
                  Param
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1635" data-mp="mh6phb1u792w">
                  <div data-id="element-1636" data-mp="rfhw7cwu53gw">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1637" data-mp="reovaskk586o">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1638" data-mp="hjnaua188uaf">
              {pages.map(page => <tr key={page.id} className="hover:bg-slate-50" data-id="element-1639" data-mp="3kf6l2q7ivzd">
                  <td className="px-3 py-2.5 border-r border-slate-200 font-medium" data-id="element-1640" data-mp="8ip3pivhs6nm">
                    {page.title}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600 truncate max-w-xs" data-id="element-1641" data-mp="1xuitpn1idtpl">
                    {page.text}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 font-mono text-xs" data-id="element-1642" data-mp="20i2yuzn1vnc0">
                    {page.param}
                  </td>
                  <td className="px-3 py-2.5 text-center" data-id="element-1643" data-mp="1whsutsitj6zs">
                    <div className="flex items-center justify-center gap-2" data-id="element-1644" data-mp="1rh4w0kocllv0">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/static-pages/view/${page.id}`)} data-id="element-1645" data-mp="1mi229wdtj22c">
                        <Eye className="h-4 w-4" data-id="element-1646" data-mp="2aefsxymic37a" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/static-pages/edit/${page.id}`)} data-id="element-1647" data-mp="25geejr010s25">
                        <Edit className="h-4 w-4" data-id="element-1648" data-mp="35g6qbbkz127y" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1649" data-mp="3af1hb0t3dx35">
                        <Trash2 className="h-4 w-4" data-id="element-1650" data-mp="3fct6vo69l746" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}